import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { theme } from '../../theme';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface YTDSalesChartProps {
  parentToChild: {
    mode: string;
  };
}

const YTDSalesChart: React.FC<YTDSalesChartProps> = ({ parentToChild }) => {
  const { mode } = parentToChild;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          color: mode === 'dark' ? '#ffffff' : '#000000',
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: 'YTD Sales vs Target',
        color: mode === 'dark' ? '#ffffff' : '#000000',
        font: {
          size: 14,
        },
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += '$' + context.parsed.y + 'M';
            }
            return label;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: mode === 'dark' ? '#ffffff' : '#000000',
        },
      },
      y: {
        beginAtZero: true,
        max: 140,
        ticks: {
          stepSize: 20,
          callback: function(tickValue: string | number) {
            return '$' + tickValue + 'M';
          },
          color: mode === 'dark' ? '#ffffff' : '#000000',
        },
        grid: {
          color: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
        },
      },
    },
  };

  const labels = ['Q1', 'Q2', 'Q3', 'Q4', 'YTD'];

  const data = {
    labels,
    datasets: [
      {
        label: 'Actual',
        data: [28, 32, 45, 38, 143],
        backgroundColor: theme.colors.secondary,
        borderRadius: 4,
      },
      {
        label: 'Target',
        data: [30, 35, 40, 45, 150],
        backgroundColor: theme.colors.primary,
        borderRadius: 4,
      },
    ],
  };

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default YTDSalesChart; 